export enum AssetType {
  Product = "PRODUCT",
  Document = "DOCUMENT",
  Question = "QUESTION",
  QuestionResponse = "QUESTION_RESPONSE",
  QuestionResponseDocument = "QUESTION_RESPONSE_DOCUMENT",
  Substance = "SUBSTANCE",
  DetailedDescriptionOfChange = "DETAILED_DESCRIPTION_OF_CHANGE",
  Invitation = "INVITATION",
  IndividualInvitation = "INDIVIDUAL_INVITATION",
  StructuredDocument = "STRUCTURED_DOCUMENT",
}

export type THAQAssetType = Extract<
  AssetType,
  AssetType.Question | AssetType.QuestionResponse
>;

export enum AssetImportType {
  External = "EXTERNAL",
  Reference = "REFERENCE",
}

export enum TransferField {
  AssetDTO = "assetDto",
  File = "file",
  OriginalFileArn = "originalFileArn",
}

export enum AssetDomain {
  Regulatory = "REGULATORY",
  System = "SYSTEM",
  Clinical = "CLINICAL",
  DrugSafetyPV = "DRUG_SAFETY_PV",
  Labeling = "LABELING",
  Nonclinical = "NONCLINICAL",
  QualityDP = "QUALITY_DP",
  QualityDS = "QUALITY_DS",
  AdminReg = "ADMIN_REG",
}

export enum AssetGroup {
  Administrative = "ADMINISTRATIVE",
  Correspondence = "CORRESPONDENCE",
  Data = "DATA",
  Users = "USERS",
  Submission = "SUBMISSION",
}

export enum AssetDefaultName {
  HAQ = "Health Authority Question",
}

export enum AssetRelationship {
  ParentOf = "PARENT_OF",
  HasAttachment = "HAS_ATTACHMENT",
  References = "REFERENCES",
  BelongsTo = "BELONGS_TO",
  Contains = "CONTAINS",
  QuestionFor = "QUESTION_FOR",
  InlineQuestionFor = "IN_LINE_QUESTION_FOR",
}

export enum AssetStatus {
  Undefined = "UNDEFINED",
  Draft = "DRAFT",
  ApprovedForSubmission = "APPROVED_FOR_SUBMISSION",
  InReview = "IN_REVIEW",
  Reviewed = "REVIEWED",
  Ready = "READY",
  Submitted = "SUBMITTED",
  Sent = "SENT",
  QAReady = "QA_READY",
  Received = "RECEIVED",
  Acknowledged = "ACKNOWLEDGED",
  Cancelled = "CANCELLED",
  Final = "FINAL",
  Uploaded = "UPLOADED",
  Uploading = "UPLOADING",
  Failed = "FAILED",
  // ToDo (AV): status Shared. Back-end doesn't provide such a status to the client side. We have to revisit it.
  Shared = "SHARED",
  Cleared = "CLEARED",
  InQualityControl = "IN_QC",
}

export enum AzureAssetUploadStatus {
  Processing = "PROCESSING",
  Failed = "FAILED",
  Successful = "SUCCESSFUL",
}
